module.exports = __webpack_public_path__ + "img/horizontal_4_5_1.a80c35fa.png";